import { render, staticRenderFns } from "./ConfigCodeModal.vue?vue&type=template&id=53ac61c6&scoped=true&"
import script from "./ConfigCodeModal.vue?vue&type=script&lang=ts&"
export * from "./ConfigCodeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigCodeModal.vue?vue&type=style&index=0&id=53ac61c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ac61c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardActions,VCardText,VDialog})
